import React, { useState, useEffect } from 'react';
import { useQuery } from '../hooks/graph';
import config from '../config';

window.mixpanel.init(config.services.mixpanel.token); // experimental

export const SetupContext = React.createContext();

// experimental / rename?
export const SetupProvider = props => {
	const [ state, setState ] = useState({});
	const [ { data: dataProviders } ] = useQuery('providers');

	// experimental
	useEffect(() => {
		const couponId = new URL(window.location.href).searchParams.get('coupon');
		couponId && setState({...state, couponId});
	}, []);

	useEffect(() => {
		dataProviders && setState(s => ({...s,
			providers: JSON.parse(dataProviders.providers).reduce((prev, curr) => ({...prev, [curr.name]: {
				...curr,
				reference: curr.reference || {},
			}}), {}),
		}));
	}, [dataProviders]);

	return state.providers ? (
		<SetupContext.Provider value={{
			...state,
		}}>
			{props.children}
		</SetupContext.Provider>
	) : false;
};

export default SetupProvider;
